import React, { useContext, Suspense } from 'react';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { AppContext } from '@thd-nucleus/app-render';
import { DataProvider } from '@thd-nucleus/data-sources';
import './styles/global-styles.scss';
import { Error } from './pages';
import { getRoutes } from './routes';
import './styles/app.scss';

export const App = ( { serverPages } ) => {
  const { instance } = useContext(AppContext);
  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent, serverPages);

  return (
    <>
      <ScrollToTop />
        <Routes>
          <Route exact path={routes.home.path} element={<routes.home.component />} />
          <Route path="/error" element={<Error />} />
          <Route element={<Error />} />
        </Routes>
    </>
  );
};

App.propTypes = {};

App.defaultProps = {};
